import { api } from './api';
export const searchApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // 全局搜索
        globalSearch: builder.query({
            query: (query) => ({
                url: '/search',
                params: { q: query },
            }),
        }),
        // 搜索建议
        searchSuggestions: builder.query({
            query: (query) => ({
                url: '/search/suggestions',
                params: { q: query },
            }),
        }),
        // 高级搜索
        advancedSearch: builder.query({
            query: ({ query, type, filters }) => ({
                url: '/search/advanced',
                params: { q: query, type, ...filters },
            }),
        }),
    }),
});
export const { useGlobalSearchQuery, useSearchSuggestionsQuery, useAdvancedSearchQuery, } = searchApi;
